export default __webpack_public_path__ + "static/truncation-do-fb6050fa22ac2a05b75d3d1d2a07821955db0075fad0d84d2495c9cb9c16333b.png";